import type { Competition } from '../../../../features/Competition/types';
import { tradingCompetitionApi } from '../../clients/clients';
import type { GetCompetitionsRequest } from '../../generated';
import { toCompetition } from './toCompetition';

export type CompetitionDetailFromListParam = {
  id: number;
  userAddress?: string;
};

const getKey = (params: CompetitionDetailFromListParam) => {
  return ['tradingCompetitionApi.getCompetitionDetailFromList', params];
};

const getFn = (params: CompetitionDetailFromListParam) => async () => {
  const listParams: GetCompetitionsRequest = {
    isReadyToDisplay: true,
    userAddress: params.userAddress,
  };

  const rawResponse = await tradingCompetitionApi.getCompetitionsRaw(listParams);
  const data = await rawResponse.value();
  const competitions = data.map(toCompetition);
  const found = competitions.find((c) => c.id === params.id);
  if (!found) throw new Error('Competition not found');
  
return found;
};

export const competitionDetailFromListQuery = {
  getKey,
  getFn,
};

export namespace CompetitionDetailFromListQuery {
  export type Param = CompetitionDetailFromListParam;
  export type Response = Competition;
}


